function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcfcfc",
  d: "M0 85.331h512v341.337H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M307.942 226.313v14.84h20.368a89.466 89.466 0 01-32.977 27.952 18.49 18.49 0 00-13.362-5.691c-8.85 0-16.248 6.2-18.1 14.492a90.227 90.227 0 01-7.871.348 90.21 90.21 0 01-7.871-.348c-1.852-8.292-9.251-14.492-18.1-14.492-5.25 0-9.987 2.185-13.362 5.69a89.46 89.46 0 01-32.976-27.951h20.368v-14.84h-51.942c0 57.373 46.511 103.884 103.884 103.884 57.374 0 103.884-46.511 103.884-103.884h-51.943z",
  fill: "#d80027"
});

const SvgRapaNui = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRapaNui, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/rapa-nui.85e30a1e.svg";
export { ForwardRef as ReactComponent };